import { Fragment } from "react";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";

const Services = () => {
  const servicios = [
    {
      icon: "fa-cart-shopping",
      title: "Pedidos en Línea",
      description:
        "Realiza tus pedidos de mayoreo en línea de forma rápida y sencilla. Accede a nuestro catálogo completo y haz tus compras desde cualquier lugar.",
      link: "https://mayoreo.govinet.app/",
    },
    {
      icon: "fa-check",
      title: "Calidad",
      description:
        "Nuestros proveedores son fabricantes de equipo original, cuentan con los más altos estándares de Calidad y son avalados con diferentes certificados de procesos y medio ambiente.",
    },
    {
      icon: "fa-shield-halved",
      title: "Garantía",
      description:
        "La calidad de nuestros productos GROB está garantizada contra defectos de fabricación por 1 año en partes de Suspensión, Dirección, Tracción Delantera, 3 años en Amortiguadores Service y garantía de por vida en Amortiguadores GROB.",
    },
    {
      icon: "fa-location-dot",
      title: "Entrega",
      description:
        "Entregamos a domicilio en menos de 4 horas en mayoreo local y de 24 a 48 horas a foráneos.",
    },
    {
      icon: "fa-globe",
      title: "Cobertura",
      description:
        "Contamos con cobertura en toda la República Mexicana a través de nuestros 10 Centros de Distribución.",
    },
    {
      icon: "fa-car",
      title: "Desarrollo",
      description:
        "Somos Innovadores y Vanguardistas, contamos con procesos que nos permiten desarrollar Aplicaciones de autos de reciente modelo en tiempo récord.",
    },
  ];

  const renderCard = (servicio, index) => {
    const cardContent = (
      <>
        <div className="servicios-card-icon">
          <i className={`fa-solid ${servicio.icon}`}></i>
        </div>
        <h3 className="servicios-card-title">{servicio.title}</h3>
        <p className="servicios-card-text">{servicio.description}</p>
        {servicio.link && (
          <span className="servicios-card-link">
            Ir al portal <i className="fa-solid fa-arrow-right"></i>
          </span>
        )}
      </>
    );

    if (servicio.link) {
      return (
        <a
          key={index}
          href={servicio.link}
          className="servicios-card servicios-card-clickable"
          target="_blank"
          rel="noopener noreferrer"
        >
          {cardContent}
        </a>
      );
    }

    return (
      <div key={index} className="servicios-card">
        {cardContent}
      </div>
    );
  };

  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="servicios-hero">
        <div className="container">
          <div className="servicios-hero-content">
            <h1 className="servicios-hero-title">Servicios</h1>
            <p className="servicios-hero-subtitle">
              Somos Expertos en Seguridad y Confort
            </p>
          </div>
        </div>
      </div>

      {/* Sección de Servicios */}
      <div className="servicios-section">
        <div className="container">
          <div className="servicios-grid">
            {servicios.map((servicio, index) => renderCard(servicio, index))}
          </div>
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default Services;
